import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ChevronRight from '@deliveroo/icon-set/react/ChevronRight';
import P from '@deliveroo/consumer-component-library/components/P';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import { FINAL_ACTIONS } from '../../containers/OrderHelpTemplateContainer/templateTypes';

import styles from './styles.scss';

/**
 * A list of actions for the order self help menu.
 * Also if the action is a final action (currently only `live_chat`)
 * then it will display differently.
 * Currently used for dynamic actions template `action_to_action`.
 */
class OrderHelpActionRows extends Component {
  render() {
    const { iframe, actions, onActionClick } = this.props;

    return (
      actions && (
        <ul
          className={classnames(styles.list, {
            [styles['modal-list']]: iframe,
          })}
        >
          {actions.map((action) => {
            const isFinalAction = FINAL_ACTIONS.includes(action.id);

            return (
              <li key={action.id} className={styles['list-item']}>
                {/* eslint-disable-next-line react/button-has-type */}
                <button
                  onClick={() => {
                    onActionClick(action.id, action.type);
                  }}
                  className={classnames(styles['action-button'], {
                    [styles['final-action']]: isFinalAction,
                  })}
                >
                  <P>{action.text}</P>

                  {!isFinalAction && (
                    <span className={styles.icon}>
                      <Icon component={ChevronRight} size={18} />
                    </span>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      )
    );
  }
}

OrderHelpActionRows.propTypes = {
  /**
   * Whether to style the list appropriately for a modal.
   */
  iframe: PropTypes.bool.isRequired,
  /**
   * The list of actions.
   */
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
  /**
   * The onClick function for each action row, passing both the action id and type.
   */
  onActionClick: PropTypes.func.isRequired,
};

export default OrderHelpActionRows;
